<template>
    <!-- 机构申请审批 -->
    <div class="mechanismPostApproval">
        <div class="search_container">
            <el-form size="mini" ref="form" class="searchBox" :inline="true" :model="insAppData">
                <el-form-item label="名称">
                    <el-input v-model="insAppData.content" @change="getList(1)" clearable placeholder="请输入计划或机构名称"></el-input>
                </el-form-item>
                <el-form-item label="省份" class="mySelect">
                    <el-select v-model="insAppData.provinceId" @change="getList(1)" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in provinceData" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="审批状态" class="mySelect">
                    <el-select v-model="insAppData.status" @change="getList(1)" clearable placeholder="全部" style="width: 100px;">
                        <el-option v-for="item in PlanStatus" :key="item.id" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <el-button size="mini" type="primary" @click="getList(1)">查询</el-button>

        </div>
        <div class="comPractice_container">
            <div class="button_box">
                <el-button type="primary" @click="passThroughBtn('bath')" size="mini">批量通过</el-button>
                <el-button type="primary" @click="turnDownBtn('bath')" size="mini">批量驳回</el-button>
            </div>
            <basic-table v-loading="loading" :isCheckbox='true' ref="mechanismPostApprovalBasicTable" :tableHeader="InsApplicationApproval" :tableData="tableData" @operation="operation">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="data">
                    <el-button size="mini" @click="checkBtn(data.row)" type="text">查看</el-button>
                    <el-button size="mini" @click="passThroughBtn('single', data.row)" v-if="data.row.status == 1" type="text">通过</el-button>
                    <el-button size="mini" @click="turnDownBtn('single',data.row)" v-if="data.row.status == 1" type="text">驳回</el-button>
                    <el-button size="mini" @click="accountManagementbtn(data.row)" v-if="data.row.status == 2" type="text">账号</el-button>
                </template>
            </basic-table>
            <pagination :total="total" :limit.sync="limitSize" :page.sync="pageNo" @currentChange="currentChange"></pagination>
        </div>

        <!-- 驳回 -->
        <el-dialog title="驳回原因" :visible.sync="turnDownDialogVisibale" :close-on-click-modal="false" class="turnDownDialogVisibale" width="590px" :before-close="AddhandleClose">
            <div class="dialog_contenter">
                <div class="reason">驳回原因:</div>
                <el-input v-model="rejectCause" type="textarea" :rows="8" placeholder="请输入驳回内容"></el-input>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" @click="cancelBtn">取 消</el-button>
                <el-button size="mini" type="primary" @click="editSureBtn">确 定</el-button>
            </span>
        </el-dialog>

        <!-- 查看账号 -->
        <el-dialog title="账号管理" :visible.sync="accountDialogVisibale" :close-on-click-modal="false" class="accountDialogVisibale" width="690px" :before-close="AddhandleClose">
            <div class="dialog_contenter">
                <div class="reason">练习网址：{{url}}</div>
                <div class="reason">默认密码123456, 首次登陆强制修改密码</div>
            </div>

            <basic-table v-loading="loadingCopy" :isCheckbox='false' :tableHeader="accountTableHeader" :tableData="accounTableData">
                <!-- eslint-disable-next-line vue/no-unused-vars -->
                <template slot-scope="data">
                    <el-button size="mini" @click="resetPasswordBtn(data.row)" type="text">重置密码</el-button>
                </template>
            </basic-table>

            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="accountDialogVisibale = false">关 闭</el-button>
            </span>
        </el-dialog>

        <!-- 查看 -->
        <el-dialog title="查看机构申请信息" :visible.sync="checkDialogVisibale" :close-on-click-modal="false" class="checkDialogVisibale" width="590px" :before-close="AddhandleClose">
            <div class="dialog_contenter">
                <el-form ref="checkFormData" :model="checkFormData" label-width="100px">
                    <el-form-item label="大赛练习计划:">
                        <!-- checkFormData -->
                        {{checkFormData.schemeName || '-'}}
                    </el-form-item>
                    <div class="editCenterTwoBox">
                        <el-form-item label="专业类别:">
                            {{checkFormData.professionName || '-'}}
                        </el-form-item>
                        <el-form-item label="大赛分类:">
                            {{checkFormData.raceTypeName || '-'}}
                        </el-form-item>
                    </div>
                    <el-form-item label="计划时间:">
                        {{checkFormData.beginTime || '-'}} - {{checkFormData.endTime || '-'}}
                    </el-form-item>
                    <el-form-item label="机构名称:">
                        {{checkFormData.orgName || '-'}}
                    </el-form-item>
                    <div class="editCenterTwoBox">
                        <el-form-item label="所属省份:">
                            {{checkFormData.provinceName || '-'}}
                        </el-form-item>
                        <el-form-item label="院校类型:">
                            {{checkFormData.orgTypeName || '-'}}
                        </el-form-item>
                    </div>

                    <div class="editCenterTwoBox">
                        <el-form-item label="联系人姓名:">
                            {{checkFormData.person ||  '-'}}
                        </el-form-item>
                        <el-form-item label="联系人电话:">
                            {{checkFormData.phone || '-'}}
                        </el-form-item>
                    </div>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="checkDialogVisibale = false">关 闭</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import { InsApplicationApproval, accountTableHeader } from './globalData.js'
import fetch from '@/api/fetch.js'
export default {
    name: 'mechanismPostApproval',

    data() {
        return {
            total: 0,
            insAppData: {
                provinceId: '',
                content: '',
                status: '',
            },
            pageNo: 1,
            limitSize: 10,
            loading: false,
            loadingCopy: false,
            accountTableHeader: accountTableHeader,
            tableData: [],
            InsApplicationApproval: InsApplicationApproval,
            provinceData: [], // 省份列表
            // 1 - 待审批 (当为待审批状态时，机构可进行撤回操作，并且中心可进行 通过/驳回 的操作, 一旦中心操作后，则机构不可进行撤销操作)
            // 2 - 已通过 (通过后可进行账户的维护)
            // 3 - 已驳回 (驳回后,机构可进行编辑，并重新提交)
            PlanStatus: [
                { id: 1, name: '待审批', value: 1 },
                { id: 2, name: '已通过', value: 2 },
                { id: 3, name: '已驳回', value: 3 }
            ],
            applyIdList: [], // 申请的主键Id
            turnDownDialogVisibale: false,
            accountDialogVisibale: false,
            checkDialogVisibale: false,
            rejectCause: '',
            reviseStr: '', // 用来判断是否批量驳回的按钮
            rowData: {},
            accounTableData: [],
            checkFormData: {}, // 查看机构申请信息回显
            selectData: [],
            currentTimeout: null,
            url: ''
        };
    },

    mounted() {
        this.getProvinceList()
        this.getList()

    },

    methods: {
        currentChange(val) {
            this.limitSize = val.limit
            this.pageNo = val.page
            this.currentTimeout = setTimeout(() => {
                this.getList(this.pageNo)
            },30)
        },
        getList(page) {
            this.loading = true
            let statusList = {
                1: '待审批',
                2: '已通过',
                3: '已驳回'
            }
            fetch.getlistApplyPage({ ...this.insAppData, pageNo: page || this.pageNo, limitSize: this.limitSize }).then(res => {
                if (res.code == '0') {
                    this.loading = false
                    this.tableData = res.data.records.map(item => {
                        return { ...item, statusText: statusList[item.status] }
                    })
                    this.total = res.data.total
                    this.pageNo = res.data.current
                    this.limitSize = res.data.size
                } else {
                    this.loading = false
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.loading = false
            })

        },
        async getProvinceList() { // 获取省份
            const res = await fetch.getProvinceList()
            if (res.code == '0') {
                this.provinceData = res.data
            } else {
                this.$message.error(res.msg)
            }
        },
        getmMnagerApprove(data) { // 通过申请
            fetch.getmMnagerApprove(data).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        passThroughBtn(type, data) { // 批量通过只能让待审批的计划通过 待审批 - 1
            if (type == 'bath') {
                if (this.applyIdList <= 0) {
                    this.$message.error('请批量选择通过的计划')
                } else {
                    let isWaitApply = false
                    // console.log(this.selectData)
                    this.selectData.forEach((item) => {
                        if (item.status != 1) {
                            isWaitApply = true
                        }
                    })

                    if (isWaitApply) {
                        this.$message.error('批量通过只能 待审批 状态的计划可以使用')
                    } else {
                        this.getmMnagerApprove({ applyIdList: this.applyIdList })
                        this.applyIdList = []
                        this.$refs.mechanismPostApprovalBasicTable.$refs.basicTable.$parent.getClearSelect()
                    }

                }
            } else {
                this.getmMnagerApprove({ applyIdList: [data.applyId] })
            }

        },
        operation(type, rowData) {
            if (type == 'selectChange') {
                this.selectData = rowData

                this.applyIdList = rowData.map(item => {
                   return item.applyId
                })

            }
        },
        cancelBtn() {
            this.turnDownDialogVisibale = false
            this.rejectCause = ''
        },
        AddhandleClose() {
            this.checkDialogVisibale = false
            this.turnDownDialogVisibale = false
            this.accountDialogVisibale = false
            this.rejectCause = ''
        },
        editSureBtn() {
            if (this.reviseStr == 'bath') {
                this.getManageReject({ rejectCause: this.rejectCause, applyIdList: this.applyIdList })
                this.turnDownDialogVisibale = false
                this.rejectCause = ''
                this.getList()
                this.$refs.mechanismPostApprovalBasicTable.$refs.basicTable.$parent.getClearSelect()

            } else {
                this.getManageReject({ rejectCause: this.rejectCause, applyIdList: [this.rowData.applyId] })
                this.turnDownDialogVisibale = false
                this.rejectCause = ''
                this.getList()
            }

        },
        getManageReject(data) { // 驳回申请
            fetch.getManageReject(data).then(res => {
                if (res.code == '0') {
                    // console.log(res)
                    this.$message.success(res.msg)
                    this.getList()
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        turnDownBtn(type, rowData) {
            if (type == 'bath') { // status != 1 - 批量驳回禁用

                let isLogo = false
                // 如果勾选的计划中存在除了 状态不统一的状态就进行提示
                if (this.selectData.length <= 0) {
                    this.$message.error('请批量选择驳回的计划')
                    return false
                } else {
                    this.selectData.forEach(item => {
                        if (item.status != 1) {
                            isLogo = true
                        }
                    })
                }

                if (isLogo) {
                    this.$message.error('批量驳回只能 待审批 状态的计划可以使用')
                } else {
                    this.reviseStr = 'bath'
                    this.turnDownDialogVisibale = true
                }

            } else {
                this.rowData = rowData
                this.reviseStr = 'single'
                this.turnDownDialogVisibale = true
            }
        },
        resetPasswordBtn(rowData) { // 重制密码按钮
            fetch.setResetPassword({ userId: rowData.userId }).then(res => {
                if (res.code == '0') {
                    this.$message.success(res.msg)
                    this.getAccountList({ schemeId: this.rowData.schemeId, orgId: this.rowData.orgId })
                } else {
                    this.$message.error(res.msg)
                }
            })
        },
        accountManagementbtn(rowData) {
            this.rowData = rowData
            this.accountDialogVisibale = true
            this.getAccountList(rowData)

        },
        getAccountList(rowData) {
            this.loadingCopy = true
            fetch.getmanagerListAccount({ schemeId: rowData.schemeId, orgId: rowData.orgId }).then(res => {
                if (res.code == '0') {
                    this.loadingCopy = false
                    this.accounTableData = res.data;
                    (res.data) && (this.url = res.data[0]?.url)
                } else {
                    this.loadingCopy = false
                    this.$message.error(res.msg)
                }
            }).catch(() => {
                this.loadingCopy = false
            })
        },
        checkBtn(rowData) {
            this.checkDialogVisibale = true
            fetch.getApplyInfoById({ applyId: rowData.id }).then(res => {
                if (res.code == '0') {
                    this.checkFormData = res.data
                } else {
                    this.$message.error(res.msg)
                }
            })
        }

    },
    beforeDestroy() {
        clearTimeout(this.currentTimeout)
        this.currentTimeout = null
    },
    components: {
        BasicTable: () => import('@/components/basicTable.vue'),
        Pagination: () => import('@/components/pagination.vue')
    }
};
</script>

<style lang="scss" scoped>
.mechanismPostApproval {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    .search_container {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        height: 60px;
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding-left: 20px;
        box-sizing: border-box;
    }
    .comPractice_container {
        width: 100%;
        height: calc(100% - 80px);
        background-color: #fff;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
        padding: 10px 20px 20px 20px;
        box-sizing: border-box;
    }
    .button_box {
        display: flex;
        height: 60px;
        justify-content: flex-end;
        align-items: center;
    }
    .searchBox {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        /deep/.el-form-item {
            margin-bottom: 0;
        }
    }
    .mySelect {
        /deep/.el-select {
            /deep/.el-input {
                width: 100px;
            }
        }
    }

    .turnDownDialogVisibale {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding: 30px 54px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .reason {
            margin-bottom: 10px;
        }
    }

    .accountDialogVisibale {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding: 30px 54px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .reason {
            margin-bottom: 10px;
            color: #409eff;
        }
    }
    .checkDialogVisibale {
        /deep/.el-dialog__footer {
            text-align: center;
        }
        /deep/.el-dialog__header {
            border-bottom: 1px solid #ccc;
        }
        /deep/ .el-dialog__title {
            font-size: 14px;
        }
        /deep/ .el-dialog__body {
            padding-left: 150px;
            padding-bottom: 0px;
        }
        .dialog_contenter {
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-content: center;
        }
        .editCenterTwoBox {
            display: flex;
            justify-content: flex-start;
        }
    }

    .basicTable {
        margin-top: 10px;
        height: 300px;
    }
}
</style>